/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：934
 */

module.exports = {
  warnBox: "style_warnBox__SQu4N",
  content: "style_content__37Obt",
  link: "style_link__3A1hv",
  icon: "style_icon__aEZqr"
}
